<mat-form-field class="w-100"  [ngClass]="{'with-units': units}">
  <!-- FixMe: Quitar el  [value]="control.value" cuando se sincronicen bien los campos del form de record con edocs-->
  <input matInput placeholder="{{ placeholder ? ('common.text.'+ placeholder | translate) : ''}}" [value]="control.value" [type]="type" [maxlength]="maxLength" [formControl]="control" autocomplete="off">
  <span *ngIf="units" class="units">{{units}}</span>
  <mat-hint align="end" *ngIf="maxLength">{{control.value?.length || 0}}/{{maxLength}}</mat-hint>
  <app-control-messages [control]="control"></app-control-messages>
</mat-form-field>
